import config from '__api/config';
import { zqhdApi } from '__api/zqhd/creatZqhdRequest';

export interface GetDrawConfigInfoRes {
  newUserTaskId: string; // 新用户抽奖任务id
  normalTaskId: string; //普通任务抽奖任务id
  surpriseTaskId: string; //惊喜任务抽奖任务id
}
interface drwardRspDTO {
  data: GetDrawConfigInfoRes;
}
/*完成任务*/
export async function getDrawConfigInfo() {
  const url = config.zqhpLink + '/activity/competition-welfare/getRewardPoolConfig';
  return zqhdApi.fetch<drwardRspDTO>(url);
}
